<template>
  <div>
    <vxe-card size="mini" width="100%">
      <div slot="title">
        <vxe-button content="tab.invoiceDetails" icon="vxe-icon-arrows-left" mode="text" status="primary" @click="back"/>
      </div>
      <div slot="extra">
        <vxe-input v-model="query.no" clearable placeholder="business.label.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.name" clearable placeholder="business.label.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query.barcodes" clearable placeholder="business.label.itemBarcode" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-button-group style="margin-left: 4px">
          <vxe-button :loading="loading" content="button.query" icon="vxe-icon-search" mode="text" status="primary" @click="refresh"/>
          <vxe-button content="button.reset" icon="vxe-icon-undo" mode="text" status="danger" @click="reset"/>
        </vxe-button-group>
      </div>
      <vxe-table
        ref="table"
        :data="data"
        :export-config="{}"
        :height="height"
        :keyboard-config="{isArrow: true}"
        :row-config="{isCurrent: true, isHover: true}"
        :column-config="{resizable: true}"
        :scroll-x="{enabled: true}"
        align="center"
        :loading="loading"
        border
        round
        show-header-overflow
        show-overflow
        size="mini"
        stripe>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
        <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
        <vxe-column field="storer.name" title="business.label.storer" width="120"/>
        <vxe-column field="customer.no" title="business.label.customerNo" width="100"/>
        <vxe-column field="customer.name" title="business.label.customerName" width="120"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName" width="120"/>
        <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="pack.innerFactor" title="business.label.innerFactor" width="60"/>
        <vxe-column field="lot.no" title="business.label.lotNo" width="150"/>
        <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
        <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
        <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
        <vxe-column field="detail.plannedQuantity" title="business.label.plannedQuantity" width="80"/>
        <vxe-column field="detail.actualQuantity" title="business.label.actualQuantity" width="80"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.invert" icon="vxe-icon-undo" status="danger" @click.stop="invert(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <div slot="footer">
        <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
      </div>
    </vxe-card>
    <detail-inversion-editor ref="inversionEditor" @success="refresh()"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'
import { findAll } from '@/api/Api'
import { ShipmentOrder } from '@/api/dto/order/ShipmentOrder'
import { Item } from '@/api/dto/common/Item'
import DetailInversionEditor from '@/views/outbound/dispatch_order/DetailInversionEditor.vue'

export default {
  components: { DetailInversionEditor },
  data() {
    return {
      loading: false,
      data: [],
      query: new Item(),
      order: new ShipmentOrder(),
      dictionary: {},
      page: 1,
      size: 20,
      contentSize: 0,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.8)
    }
  },
  methods: {
    back() {
      this.$emit('back')
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch(record) {
      if (record) {
        this.order = new ShipmentOrder(record.order)
      }
      if (this.order.isNew()) {
        return this.$message.warning('请先选择单据')
      }
      const args = {
        'order.id': this.order.id,
        item: this.query.toJSONObject()
      }
      this.loading = true
      findAll('shipmentDetailFactory', args, this.page, this.size).then((res) => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new Item()
      this.refresh()
    },
    invert(row) {
      this.$refs.inversionEditor.open(row)
    }
  }
}
</script>